import React from 'react';

// Shows the whole image (object-contain) over a blurred, cover-filled copy of itself.
// The parent decides the size; className/imgClassName are passed through.
const BlurImage = ({ src, alt = '', className = '', imgClassName = '' }) => {
  return (
    <div
      className={`tw-relative tw-overflow-hidden tw-bg-gray-100 ${className}`}
    >
      {src && (
        <>
          <img
            src={src}
            alt=""
            aria-hidden="true"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-scale-110 tw-blur-xl tw-opacity-80"
          />
          <img
            src={src}
            alt={alt}
            width={600}
            height={400}
            className={`tw-relative tw-w-full tw-h-full tw-object-contain ${imgClassName}`}
          />
        </>
      )}
    </div>
  );
};

export default BlurImage;
